import { UseFormGetValues } from "react-hook-form";
import { ConsentedCheckboxes, FormValues } from "../../types/form";
import { Path } from "../../types/route";
import { Confirm } from "./Confirm";
import { useConfirm } from "./hooks";

interface ConfirmContainerProps {
  setPath: (path: Path) => void;
  getValues: UseFormGetValues<FormValues>;
  value: ConsentedCheckboxes;
  onChange: (isConsented: ConsentedCheckboxes) => void;
  parentCode: string | undefined;
}

export function ConfirmContainer({
  setPath,
  getValues,
  value,
  onChange,
  parentCode,
}: ConfirmContainerProps) {
  const useConfirmProps = useConfirm({
    getValues,
    parentCode,
  });

  return (
    <Confirm
      setPath={setPath}
      isConsented={value}
      onClickCheckbox={onChange}
      {...useConfirmProps}
    />
  );
}
